import { lang } from "i18nLang";

export class ParentRowNotFoundException extends Error {
  protected _code: string;

  constructor(structured: string) {
    super(lang("addsAndCancels.messages.error.parentRowNotFound", structured));

    this.name = "ParentRowNotFoundException";
    this._code = "parentRowNotFound";
  }
}

export class ParentRowIsNotStageException extends Error {
  protected _code: string;

  constructor(structured: string) {
    super(
      lang("addsAndCancels.messages.error.parentRowIsNotStage", structured)
    );

    this.name = "ParentRowIsNotStageException";
    this._code = "parentRowIsNotStage";
  }
}
